import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  ChangeDetectorRef
} from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { forkJoin } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import { CodeType } from 'src/app/enums/enum';

@Component({
  selector: 'app-vom',
  templateUrl: './vom.component.html',
  styleUrls: ['./vom.component.scss']
})
export class VOMComponent implements OnInit {
// base API url
baseUrl = environment.baseUrl;
frmSingleLicense: FormGroup;
frmMultiLicense: FormGroup;
frmCaptcha: FormGroup;
conditions: any = {};
errorMessage = '';
hasError = false;
licenseFiles: File[] = [];
captcha: any = {};
confirmType = '';
codeTypes: any[] = [];
licenseTypes: any[] = [];
modelNameTypes: any[] = [];
expireDateTypes: any[] = [];
filterExpireDateTypes: any[] = [];
licenseTypesFree: any[] = [];
modelNameTypesFree: any[] = [];
applicationTypes: any[] = [];
vmsTypes: any[] = [];
license: string = 'free';
generateVisible: boolean = false;
codeVisible: boolean = true;
fileuploadVisible: boolean = false;
TextboxVisible: boolean = false;
adminContact: string = '';

@ViewChild('confirmSwal') confirmSwal: SwalComponent;
@ViewChild('licenseFileElem') licenseFileElem: ElementRef;

get frmSingle() {
  return this.frmSingleLicense.controls;
}

get frmMulti() {
  return this.frmMultiLicense.controls;
}

constructor(
  private fb: FormBuilder,
  private cd: ChangeDetectorRef,
  private commonSvc: CommonService,
  private spinnerSvc: NgxSpinnerService,
  private route: ActivatedRoute
) {


}

ngOnInit() {
  // this.route.queryParams.subscribe(params => {
  //   const id = params['id'];
  //   if (id) {
  //     this.commonSvc.generateVOMLicense(id).subscribe((response: any) => {
  //       if (response.status) {
  //         window.open(
  //           `${this.baseUrl}/Generate/LicenseVOMFile?id=${response.resultObj}`,
  //           '_blank'
  //         );
  //       } else {
  //         // this.hasError = true;
  //         // this.errorMessage = response.msg;
  //         alert(response.msg);
  //       }
  //       this.spinnerSvc.hide();
  //     },
  //     (err: any) => {
  //       this.hasError = true;
  //       this.errorMessage = err.error.exceptionMessage;
  //       this.spinnerSvc.hide();
  //     });
  //     this.router.navigate(['/vision-object-metadata']);
  //   }
  // });
  this.license = 'vom';
  this.route.params.subscribe(params => {
    if(this.license === 'vom')
    {
      console.log(this.license);
      forkJoin([this.commonSvc.getCodeTypes()]).subscribe(([codeTypes]) => {
        this.codeTypes = codeTypes;

        // this.modelNameTypes = this.codeTypes.filter(
        //   item => item.codeTypeId === CodeType.ModelNameVOM
        // );
        this.licenseTypes = this.codeTypes.filter(
          item => item.codeTypeId === CodeType.LicenseTypeVOM
        );
        this.applicationTypes = this.codeTypes.filter(
          item => item.codeTypeId === CodeType.ApplicationType
        );
        this.vmsTypes = this.codeTypes.filter(
          item => item.codeTypeId === CodeType.VMSType
        );
        this.adminContact = this.codeTypes.filter(
          item => item.codeTypeId === CodeType.adminContact
        )[0].text;
      });
    }else{
      forkJoin([this.commonSvc.getCodeTypes()]).subscribe(([codeTypes]) => {
        this.codeTypes = codeTypes;
        this.modelNameTypes = this.codeTypes.filter(
          item => item.codeTypeId === CodeType.ModelName
        );
      });
    }
  });


  // initialize single-license form
  this.frmSingleLicense = this.fb.group({
    email: [null, [Validators.required, Validators.email]],
    company: [null, [Validators.required,]],
    contact: [null, [Validators.required]],
    contactPersionPhone: [null, [Validators.required]],
    country: [null, [Validators.required]],
    applicationType: [null, [Validators.required]],
    modelName: [null, [Validators.required]],
    license :[this.license],
    macAddress: [
      '',
      [
        Validators.required,
        Validators.pattern('^0002[dD]{1}1[A-Fa-f0-9]{6}$')
      ]
    ],
    licenseType: [null, [Validators.required]],
    expireDate: [null]
  });

  // initialize multi-license form
  this.frmMultiLicense = this.fb.group({
    terms: [false, Validators.requiredTrue],
    option: ['single', Validators.required],
    email: [null, [Validators.required, Validators.email,Validators.pattern(/^(?!.*@vivotek\.com$).*$/)]],
    company: [null, [Validators.required,]],
    contact: [null, [Validators.required]],
    contactPersionPhone: [null, null],
    country: [null, [Validators.required]],
    applicationType: [null, [Validators.required]],
    vmsType: [null, [Validators.required]],
    description: ['', null],//Validators.required, Validators.minLength(80),Validators.maxLength(300)
    code: [null,null],
    // code: [null,[Validators.required,
    //     Validators.maxLength(30),
    //     Validators.minLength(10),
    //     Validators.pattern('^[a-zA-Z0-9-]+$')]
    //     ],
    licenseFile: [null,null],
    modelName: [null, null],
    macAddress: [null, null],
    licenseType: [null, null],
  });

  // captcha form
  this.frmCaptcha = this.fb.group({
    image: [null, [Validators.required]]
  });

  // expire date
  // this.filterExpireDateTypes = this.expireDateTypes.filter(
  //   item =>
  //     item.referenceId === this.frmSingleLicense.get('licenseType').value
  // );
  this.frmMultiLicense.get('licenseType').valueChanges.subscribe(val => {
    // get referenceIds
    if (val) {
      {
        // const referenceIds = this.modelNameTypes
        //   .filter(
        //     item => item.codeTypeId === CodeType.ModelNameVOM && item.id === val
        //   )
        //   .map(item => [...item.referenceId])[0];
        //   console.log(referenceIds);
        // this.licenseTypes = this.codeTypes.filter(
        //   item =>
        //     item.codeTypeId === CodeType.LicenseTypeVOM &&
        //     referenceIds.includes(item.id)
        // );
        console.log(val);
        console.log(this.licenseTypes);
        this.frmMultiLicense.get('modelName').setValue("");
        const id = this.licenseTypes
          .filter(
            item => item.codeTypeId === CodeType.LicenseTypeVOM && item.codeId === val
          )[0].id;
          console.log(id);
          console.log(this.codeTypes.filter(
            item =>
              item.codeTypeId === CodeType.ModelNameVOM
          ));
        this.modelNameTypes = this.codeTypes.filter(
          item =>
            item.codeTypeId === CodeType.ModelNameVOM &&
          item.referenceId && item.referenceId.includes(id)
        );

        console.log(this.modelNameTypes);
      }
    }
  });
  this.frmMultiLicense.get('option').valueChanges.subscribe(selectedValue => {
    if(selectedValue){
      this.MultValidators(selectedValue);
    }
  });
}
MultValidators(selectedValue: string) {
  console.log(selectedValue);
  if(selectedValue==='single'){
    this.TextboxVisible = true;
    this.fileuploadVisible = false;
    this.frmMulti['licenseFile'].clearValidators();
    this.frmMulti['licenseType'].setValidators(Validators.required);
    this.frmMulti['modelName'].setValidators(Validators.required);
    this.frmMulti['macAddress'].setValidators([Validators.required,Validators.pattern('^0002[dD]{1}1[A-Fa-f0-9]{6}$')]);
  }else{
    this.fileuploadVisible = true;
    this.TextboxVisible = false;
    this.frmMulti['licenseFile'].setValidators(Validators.required);
    this.frmMulti['licenseType'].clearValidators();
    this.frmMulti['modelName'].clearValidators();
    this.frmMulti['macAddress'].clearValidators();
  }
  this.frmMulti['licenseFile'].updateValueAndValidity();
  this.frmMulti['licenseType'].updateValueAndValidity();
  this.frmMulti['modelName'].updateValueAndValidity();
  this.frmMulti['macAddress'].updateValueAndValidity();
}

handleConfirm(confirmType: string) {
  this.confirmType = confirmType;
  console.log(this.confirmType);
}

beforeOpen(evt) {
  this.commonSvc.getCaptcha().subscribe((response: any) => {
    if (response.status) {
      this.captcha = response.resultObj;
    }
  });
}

submit() {
  this.commonSvc
    .verifyCaptcha({
      key: this.captcha.key,
      image: this.frmCaptcha.get('image').value
    })
    .subscribe((response: any) => {
      if (response.status) {
        this.confirmSwal.nativeSwal.close();
        console.log(this.confirmType);
        switch (this.confirmType) {
          case 'single':
            //this.submitSingle();
            break;
          case 'multi':
            this.submitMulti();
            break;
        }
      }
    });
  this.frmCaptcha.patchValue({ image: '' });
}

private submitSingle() {
  this.spinnerSvc.show();
  this.conditions = { ...this.frmSingleLicense.value };
  // override modelName from id to text
  this.conditions.modelName = this.modelNameTypes.filter(
    item => item.id === this.frmSingleLicense.get('modelName').value
  )[0].text;

  this.commonSvc.requestSingleLicense(this.conditions).subscribe(
    (response: any) => {
      if (response.status) {
        window.open(
          `${this.baseUrl}/Generate/File?id=${response.resultObj}`,
          '_blank'
        );
      } else {
        this.hasError = true;
        this.errorMessage = response.msg;
      }
      this.spinnerSvc.hide();
    },
    (err: any) => {
      this.hasError = true;
      this.errorMessage = err.error.exceptionMessage;
      this.spinnerSvc.hide();
    }
  );

  this.frmSingleLicense.reset();
}

private submitSingleAndSendMail() {
  this.spinnerSvc.show();
  this.conditions = { ...this.frmSingleLicense.value };
  // override modelName from id to text
  this.conditions.modelName = this.modelNameTypes.filter(
    item => item.id === this.frmSingleLicense.get('modelName').value
  )[0].text;

  this.commonSvc.requestSingleAndSendMailLicense(this.conditions).subscribe(
    (response: any) => {
      if (response.status) {
        alert(response.msg);
      } else {
        this.hasError = true;
        this.errorMessage = response.msg;
      }

      this.spinnerSvc.hide();
    },
    (err: any) => {
      this.hasError = true;
      this.errorMessage = err.error.exceptionMessage;
      this.spinnerSvc.hide();
    }
  );

  this.frmSingleLicense.reset();
}

private submitMulti() {
  this.spinnerSvc.show();
  var modelName = '';
  var licenseTypeName = '';
  if(this.frmMulti['option'].value === 'single' && this.frmMulti['vmsType'].value !=='Else')
  {
    // override modelName from id to text
     modelName = this.modelNameTypes.filter(
      item => item.id === this.frmMultiLicense.get('modelName').value
    )[0].text;
    licenseTypeName = this.licenseTypes.filter(
      item => item.codeId === this.frmMultiLicense.get('licenseType').value
    )[0].text;
  }
  this.commonSvc
    .requestVOMLicenses(
      this.licenseFiles,
      this.frmMultiLicense.get('email').value,
      this.frmMultiLicense.get('company').value,
      this.frmMultiLicense.get('contact').value,
      this.frmMultiLicense.get('contactPersionPhone').value,
      this.frmMultiLicense.get('country').value,
      this.frmMultiLicense.get('applicationType').value,
      this.frmMultiLicense.get('vmsType').value,
      this.frmMultiLicense.get('code').value,
      licenseTypeName,
      modelName,
      this.frmMultiLicense.get('macAddress').value,
      this.frmMultiLicense.get('description').value
    )
    .subscribe(
      (response: any) => {
        if (response.status) {
          // window.open(
          //   `${this.baseUrl}/Generate/File?id=${response.resultObj}`,
          //   '_blank'
          // );
          this.hasError = true;
          if(this.frmMulti['vmsType'].value ==='Else') {
            this.errorMessage = 'Thank you for your submission. We will contact you and inform you as soon as possible.';
          }
          else {
            this.errorMessage = 'The download link has been sent to your email.';
          }
        } else {
          this.hasError = true;
          this.errorMessage = response.msg;
        }
        alert(this.errorMessage);
        this.spinnerSvc.hide();
      },
      (err: any) => {
        this.hasError = true;
        this.errorMessage = err.error.exceptionMessage;
        this.spinnerSvc.hide();
      }
    );

  this.resetFileInput();
}

fileChanged(event: any) {
  const reader = new FileReader();
  if (event.target.files && event.target.files.length) {
    console.log(event);
    const [file] = event.target.files;
    this.licenseFiles = [...this.licenseFiles, file];

    reader.readAsDataURL(file);
    reader.onload = () => {
      this.frmMultiLicense.patchValue({
        file: reader.result
      });
      this.cd.markForCheck();
    };
  }
}

resetFileInput() {
  this.licenseFiles = [];
  this.frmMultiLicense.get('licenseFile').reset();
  this.licenseFileElem.nativeElement.value = '';
}
onChange(value: any) {
  //this.MultValidators(this.frmMultiLicense.get('option').value);
  if(this.frmMulti['vmsType'].value ==='Else'){
    //this.frmMulti['code'].setValue('VisionObjectMetadataElse');
    this.generateVisible = false;
    this.codeVisible = false;
    this.TextboxVisible = false;
    this.fileuploadVisible = false;
    //this.frmMulti['code'].clearValidators();
    this.frmMulti['licenseFile'].clearValidators();
    this.frmMulti['licenseType'].clearValidators();
    this.frmMulti['modelName'].clearValidators();
    this.frmMulti['macAddress'].clearValidators();
    this.frmMulti['description'].setValidators([Validators.required,Validators.required, Validators.minLength(80),Validators.maxLength(300)]);
  }else{
    //this.frmMulti['code'].setValue('');
    this.frmMulti['option'].setValue('single');
    this.generateVisible = true;
    this.TextboxVisible = true;
    this.codeVisible = true;
    //this.frmMulti['code'].setValidators(Validators.required);
    this.frmMulti['licenseFile'].clearValidators();
    this.frmMulti['licenseType'].setValidators(Validators.required);
    this.frmMulti['modelName'].setValidators(Validators.required);
    this.frmMulti['macAddress'].setValidators(Validators.required);
    this.frmMulti['macAddress'].setValidators([Validators.required,Validators.pattern('^0002[dD]{1}1[A-Fa-f0-9]{6}$')]);
    this.frmMulti['description'].clearValidators();
  };
  //this.frmMulti['code'].updateValueAndValidity();
  this.frmMulti['licenseFile'].updateValueAndValidity();
  this.frmMulti['licenseType'].updateValueAndValidity();
  this.frmMulti['modelName'].updateValueAndValidity();
  this.frmMulti['macAddress'].updateValueAndValidity();
  this.frmMulti['description'].updateValueAndValidity();
}
// ApplyDisable() {
//     var b = !(this.frmMultiLicense.valid && this.frmMulti['licenseFile'].value !== null);
//     return b;
//   }
ApplyDisable() {
  // console.log(this.frmMulti['code'].value);
  // console.log(this.isFilled(this.frmMulti['licenseType'].value));
  // console.log(this.isFilled(this.frmMulti['modelName'].value));
  // console.log(this.isFilled(this.frmMulti['macAddress'].value));
  // // console.log(this.MacRequire());
  // if (!this.MacRequire() && !this.FileRequire()) {
  //    return true;
  // }
  var b = !(this.frmMultiLicense.valid);
    return b;
  }
  MacRequire() {
    //console.log((!this.frmMulti['licenseType'].value && !this.frmMulti['modelName'].value && this.frmMulti['macAddress'].value));
    //return (this.frmMulti['licenseType'].value && this.frmMulti['modelName'].value && this.frmMulti['macAddress'].value);
    if (this.isFilled(this.frmMulti['licenseType'].value) &&
    this.isFilled(this.frmMulti['modelName'].value) &&
    this.isFilled(this.frmMulti['macAddress'].value))  {

    // 如果三个字段都不为空或空白
    return false;
  } else {
    // 如果其中有任何一个字段为空或空白
    return true;
  }
  }
  FileRequire() {
    return (this.frmMulti['licenseFile'].value === null);
  }
  isFilled(value: string | null): boolean {
    return value === null || value === '';
  }
}
